module.exports = __webpack_public_path__ + "static/media/AMC-background.0e729755.svg";